import React from 'react';
import { withStyles, useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { format, getTimeInIST, toInt, HtmlTooltip } from '../Utils';
import { Grid, Divider, Fade, MenuItem, FormControl, Select, InputLabel, AppBar, Toolbar, List, ListItemText, TextField, Tooltip, Icon, Hidden, CircularProgress, Checkbox, CardHeader } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import AutoCompleteSelection from "./AutoCompleteSelection";
import moment from 'moment';
import { WarehouseService } from '../Services/WarehouseService';
import { Autocomplete } from '@material-ui/lab';
import { DeliveryService } from '../Services/DeliveryService';
import DeleteIcon from '@material-ui/icons/Delete';

let counter = 0;

const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    },
    formControl: {
        margin: theme.spacing(0),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    autoCompleteSelectionTextField: {

    }
}));

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function NewTransactionDialog(props) {
    const [open, setOpen] = React.useState(props.id ? true : false);
    const [loading, setLoading] = React.useState(false);

    const theme= useTheme();

    const [title, setTitle] = React.useState(undefined);
    const [details, setDetails] = React.useState([]); 
    const [transaction, setTransaction] = React.useState({txn_date: moment()});
    const [tproducts, setTProducts] = React.useState([]); 

    const [sources, setSources] = React.useState([]);
    const [reasons, setReasons] = React.useState([]);
    const [stockType, setStockType] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [addItemRows, setAddItemRows] = React.useState([]);
    const [checkedList, setCheckedList] = React.useState([]);

    const classes = useStyles();

    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    React.useEffect(() => {
        if(props.master_sources){
            setSources(props.master_sources.map((element) =>(
                ({key: element.id, id: element.id, value: element.name, type: element.type ?  "AGENT" : "WAREHOUSE",  label: element.type ? `${element.name} [Agent]` : `${element.name} [Warehouse]`})
            )));
            setReasons(props.master_reasons.map(types => (<MenuItem key={types.code} value={types.code} name={types.ownership_id}>{types.description}</MenuItem>)));
            setStockType(props.master_stock_type.slice(1).map(types => (<MenuItem key={types.id} value={types.id}>{types.name}</MenuItem>)));
            setProducts(props.master_products.filter(p => p.status !== -1).map((element) =>(
                ({key: element.id, id: element.id, name: element.name, value: element.name, label: element.name, unit: element.unit_size})
            )));
        }
    }, [props.master_sources, props.master_products, props.master_reasons]);

    // const [inputs, setInputs] = useState({});
    const handleChange = (event) => {
        event.persist();
        if(transaction[event.target.name]){
            props.showConfirmDialog("You have products already added. You will lose any changes made. Do you want to continue?", undefined, () => {
                props.closeConfirmDialog();
                setTransaction(transaction => ({...transaction, [event.target.name]: event.target.value}));
                predictQtyForDestination(event.target.value, transaction.source_id, transaction.source_type, transaction.destination_id, transaction.destination_type);
            })
        } else {
            setTransaction(transaction => ({...transaction, [event.target.name]: event.target.value}));
            predictQtyForDestination(event.target.value, transaction.source_id, transaction.source_type, transaction.destination_id, transaction.destination_type);
        }
    }

    const handleSourceSelection = (e, source) => {
        if(transaction.source_id){
            props.showConfirmDialog("Any changes made will be lost. Do you want to continue?", undefined, () => {
                props.closeConfirmDialog();
                handleSourceChange(source);  
            });
        } else {
            handleSourceChange(source);
        }
    }

    const handleSourceChange = (source) => {
        setTransaction(transaction => ({...transaction, source_id: source.id, source_type: source.type, source: source}));
        predictQtyForDestination(transaction.stock_type, source.id, source.type, transaction.destination_id, transaction.destination_type);
    }

    const handleDestinationSelection = (e, destination) => {
        if(transaction.destination_id){
            props.showConfirmDialog("Any changes made will be lost. Do you want to continue?", undefined, () => {
                props.closeConfirmDialog();
                handleDestinationChange(destination);  
            });
        } else {
            handleDestinationChange(destination);
        }
    }

    const handleDestinationChange = (destination) => {
        setTransaction(transaction => ({...transaction, destination_id: destination.id, destination_type: destination.type, destination: destination}));
        predictQtyForDestination(transaction.stock_type, transaction.source_id, transaction.source_type, destination.id, destination.type);
    }

    const predictQtyForDestination = (stock_type, source_id, source_type, destination_id, destination_type) => {
        if(source_type === 'WAREHOUSE' && destination_type === 'AGENT' && stock_type === 'FRESH'){
            setLoading(true);
            DeliveryService.getIndentForAgent(destination_id, transaction.txn_date)
            .then(data => {
                let tproducts = [];
                // updateUI(tproducts);
                setTProducts(tproducts);
                console.log(data);
                data.indent.forEach((indent) => {
                    tproducts.push({rowid: counter++, product_id: indent.product_id, qty: toInt(indent.qty), reason: '-1', name: indent.product_name, display_name: indent.display_name, unit_size: indent.unit_size, comments: "", modified: true});
                });
                // updateUI(tproducts);
                setTProducts(tproducts);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                console.log(err)
            });
        } else if(source_type === 'AGENT' && destination_type === 'WAREHOUSE'){
            setLoading(true);
            WarehouseService.getStock(source_id)
            .then(data => {
                let tproducts = [];
                // updateUI(tproducts);
                setTProducts(tproducts);
                console.log(data);
                data.stock.filter(s => s.stock_type === stock_type).forEach((stock) => {
                    let product = products.filter(p => p.id === stock.product_id)[0];
                    tproducts.push({rowid: counter++, product_id: stock.product_id, qty: toInt(stock.qty), reason: '-1', name: stock.product_name, display_name: stock.display_name, unit_size: product.unit_size, comments: "", modified: true});
                });
                // updateUI(tproducts);
                setTProducts(tproducts);
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                console.log(err)
            });
        } else {
            // updateUI([]);
            setTProducts([]);
        }
    }

    const handleDateChange = (field, date) => {
        console.log(field, date.format(format));
        if(tproducts.length > 0){
            props.showConfirmDialog("Any changes made will be lost. Do you want to continue?", undefined, () => {
                setTransaction(transaction => ({...transaction, [field]: moment.utc(date).format(format)}));
                predictQtyForDestination(transaction.stock_type, transaction.source_id, transaction.source_type, transaction.destination_id, transaction.destination_type);
            });
        } else {
            setTransaction(transaction => ({...transaction, [field]: moment.utc(date).format(format)}));
        }
    }

    const handleProductSelection = (product) => {
        // let p = tproducts;
        // tproducts.push();
        // updateUI(tproducts);
        setTProducts(tproducts => [...tproducts, {rowid: counter++, product_id: product.id, qty: 0, reason: '-1', name: product.name, display_name: product.display_name, unit_size: product.unit_size, comments: product.comments, modified: false}]);
    }

    const updateUI = () => {
        setAddItemRows(tproducts.map((product, index) => {  
            let cStock = transaction.current_stock && transaction.current_stock.filter(p => p.product_id === product.product_id && p.stock_type === 'FRESH');
            let current_stock = cStock && cStock.length > 0 ? toInt(cStock[0].qty) : 0;
            let stock_accounted = 0;
            stock_accounted = tproducts.filter(p => p.product_id === product.product_id).reduce(function(accumulator, currentValue) {
                return accumulator + toInt(currentValue.qty);
            }, stock_accounted);
            return(
                <Grid key={index + 1 + product.product_id} container spacing={1} alignItems="center" justify="flex-start">
                    <Grid item>
                        <Checkbox
                            onChange={handleToggle(product.rowid)}
                            edge="start"
                            checked={checkedList.indexOf(product.rowid) !== -1}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ 'aria-labelledby': product.name }}
                        />
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        
                            <ListItemText 
                                primary={<HtmlTooltip arrow title={product.display_name ? product.name: ''}><Typography type="subtitle1">{index + 1}{". "}{product.display_name ? product.display_name: product.name}</Typography></HtmlTooltip>} 
                                secondary={`Balance ${(current_stock - stock_accounted)}`} />
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <TextField
                            fullWidth
                            id="standard-number"
                            label="Qty"
                            defaultValue={product.modified ? product.qty : 0}
                            onChange={(e) => handleProductChange(product, e, 'qty')}
                            type="number"
                            name={product.id}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{ min: 0 }}
                            className={classes.qtyField}
                            margin="normal"
                            variant="outlined"
                            required
                            helperText={`Unit size: ${product.unit_size ? product.unit_size : ""}`}
                            style={{minWidth: 100}}
                        />
                    </Grid>
                    <Grid item xs={4} lg={2}>
                        <FormControl fullWidth variant="outlined" style={{marginBottom: 14}}>
                            <InputLabel id="outlined-reason-simple">
                                Reason
                            </InputLabel>
                            <Select
                                labelid="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                onChange={(e) => handleProductChange(product, e, 'reason')}
                                label="reason"
                                value={product.reason}
                            >
                                {reasons}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} lg={3}>
                        <TextField
                            fullWidth
                            label="Comments"
                            defaultValue={product.comments}
                            onChange={(e) => handleProductChange(product, e, 'comments')}
                            type="text"
                            name={product.id}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            className={classes.qtyField}
                            margin="normal"
                            variant="outlined"
                            helperText={`Enter Comments`}
                        />
                    </Grid>
                    <Grid item xs={2} lg={1}>
                        <Tooltip title="Remove">
                            <IconButton aria-label="Delete" onClick={(e) => removeProduct(product, e)} className={classes.icon}>
                                <Icon>delete</Icon>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Hidden mdUp>
                        <Grid item xs={12} style={{marginTop: 8}}>
                            <Divider />
                        </Grid>
                    </Hidden>
                </Grid>
            ); 
        }));
    }

    const handleProductChange = (product, e, field) => {
        let pL = tproducts.filter(p => p.rowid === product.rowid);
        pL[0][field] = e.target.value || 0;
        pL[0].modified = true;
        if(field === 'reason'){
            pL[0].ownership_id = props.master_reasons.filter(r => r.code === e.target.value)[0].ownership_id;
        }
        // updateUI(tproducts);
        setTProducts(tproducts);
    }

    const removeProduct = (product, e) => {
        props.showConfirmDialog("Confirm Remove?", undefined, () => {

            setTProducts(tproducts.filter(p => p.rowid !== product.rowid));

            // let index = tproducts.findIndex(p => p.rowid === product.rowid);
            // tproducts.splice(index, 1);
            // setTProducts(tproducts);
            // updateUI(tproducts);
            props.closeConfirmDialog();
        });
    }

    React.useEffect(() => {
        // console.log("Update UI Called", tproducts);
        updateUI();
    }, [transaction.current_stock, tproducts, checkedList]);

    React.useEffect(() => {
        if(props.transaction_id !== undefined){
            WarehouseService.getTransactionDetail(props.transaction_id)
            .then(data => {
                let transaction = {};
                transaction.transaction_id = props.transaction_id;
                if(data.details.length > 0){
                    let details = data.details[0];
                    transaction.source_id = details.source_id;
                    transaction.source_type = details.source_type;
                    if(sources.filter(s => s.id === details.source_id).length > 0)
                        transaction.source = sources.filter(s => s.id === details.source_id)[0];
                    transaction.destination_id = details.destination_id;
                    transaction.destination_type = details.destination_type;
                    if(sources.filter(s => s.id === details.destination_id).length > 0)
                        transaction.destination = sources.filter(s => s.id === details.destination_id)[0];
                    transaction.stock_type = details.stock_type;
                    transaction.txn_date = getTimeInIST(details.txn_date);
                }
                setTransaction(transaction);
                let p = [];
                data.details.forEach((element) => {
                    p.push({rowid: counter++, transaction_id: transaction.transaction_id, product_id: element.product_id, qty: toInt(element.qty), reason: element.reason_code || '-1', name: element.product_name, display_name: element.product_display_name, unit_size: element.product_unit, comments: element.comments, modified: true});
                });
                setTProducts([...tproducts, ...p]);
                // updateUI(tproducts);
                // const [tproducts, setTProducts] = React.useState([]); 
            });
        }
    }, [props.transaction_id && sources]);

    React.useEffect(() => {
        WarehouseService.getStock(transaction.source_id)
        .then(data => {
            console.log(data);
            transaction.current_stock = data.stock;
            setTransaction(transaction);
        });
    }, [transaction.source_id]);

    const handleToggle = value => (event, checked) => {
        console.log(value, checked);
        // let index = checked.indexOf(value);
        // console.log(index)
        // if(event.target.checked && index === -1){
        //     setChecked(checked => [...checked, value]);
        // } else {
        //     const newChecked = checked;
        //     newChecked.splice(index, 1);
        //     setChecked(newChecked);
        // }
        const currentIndex = checkedList.indexOf(value);
		const newChecked = [...checkedList];
	
		if (currentIndex === -1) {
		  newChecked.push(value);
		} else {
		  newChecked.splice(currentIndex, 1);
		}
	
		setCheckedList(newChecked);
	};

    React.useEffect(() => {
        let details = [];
        setTitle(props.transaction_id ? `Edit Transaction` : `New Transaction`);

        details.push(
        <Grid item container xs={12} lg={12} key={1} spacing={2} alignItems="center">
            <Grid item xs={12} lg={2}>
                <FormControl variant="outlined" className={classes.formControl} fullWidth required>
                    <InputLabel
                        htmlFor="outlined-warehouse-simple"
                    >
                        Stock Type
                    </InputLabel>
                    <Select
                        labelid="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={handleChange}
                        labelwidth={200}
                        name="stock_type"
                        value={transaction.stock_type ? transaction.stock_type: ''}
                        disabled={props.transaction_id ? true: false}
                    >
                        {stockType}
                    </Select>
                </FormControl>
            </Grid>
            {/* <Grid item xs={6} lg={3}>
                <Typography className={classes.heading} style={{textAlign: 'left'}}>Select Source</Typography>
            </Grid> */}
            <Grid item xs={12} lg={3} style={{zIndex: 5}}>
                <Autocomplete
                    id="source-selection"
                    disableClearable
                    options={sources}
                    getOptionLabel={option => option.label}
                    value={transaction.source || null}
                    required={true}
                    getOptionDisabled={option => option === transaction.destination}
                    onChange={handleSourceSelection}
                    style={{ maxWidth: '30vw', minWidth: 150, zIndex: 9999 }}
                    disabled={props.transaction_id ? true: false}
                    renderInput={params => (
                        <TextField {...params} label="Select Source" variant="outlined" fullWidth />
                    )}
                    />
            </Grid>
            {/* <Grid item xs={6} lg={3}>
                <Typography className={classes.heading} style={{textAlign: 'left'}}>Select Destination</Typography>
            </Grid> */}
            <Grid item xs={12} lg={3}>
                <Autocomplete
                    id="destination-selection"
                    disableClearable
                    options={sources}
                    getOptionLabel={option => option.label}
                    getOptionDisabled={option => option === transaction.source}
                    value={transaction.destination || null}
                    required={true}
                    onChange={handleDestinationSelection}
                    style={{ maxWidth: '30vw', minWidth: 150, zIndex: 9999 }}
                    disabled={props.transaction_id ? true: false}
                    renderInput={params => (
                        <TextField {...params} label="Select Destination" variant="outlined" fullWidth />
                    )}
                    />
            </Grid>
            <Grid item xs={6} lg={2}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DateTimePicker
                            label="Transaction Date"
                            inputVariant="outlined"
                            value={transaction.txn_date ? getTimeInIST(transaction.txn_date) : moment()}
                            disablePast={props.transaction_id ? false: true}
                            fullWidth
                            disabled={props.transaction_id ? true: false}
                            format='DD MMM YYYY HH:mm'
                            onChange={date => {
                                handleDateChange("txn_date", date);
                            }}
                        />
                </MuiPickersUtilsProvider>
            </Grid>
            {/* <Hidden mdDown>
                <Grid item xs={2} lg={2}>
                    <Typography variant="body2" style={{fontSize: 18}}>Select Product</Typography>
                </Grid>
            </Hidden> */}
            <Grid item xs={6} lg={2}>
                { (transaction.source_id && transaction.destination_id && transaction.stock_type) &&
                <FormControl 
                    fullWidth 
                    className={classes.formControlAutoComplete} 
                    style={{zIndex: 2}}>
                    <AutoCompleteSelection
                        placeHolder="Select Product"
                        onChange={handleProductSelection}
                        name="product"
                        isMulti={false}
                        value={[transaction.products]}
                        options={products}/>
                </FormControl>
                }
            </Grid>
            <Grid item xs={12} lg={12}>
                <Divider variant="fullWidth" style={{marginBottom: 5, marginTop: 5}}/>
            </Grid>
        </Grid>);
        setDetails(details);

    }, [transaction, sources, reasons, products, stockType]);

    const handleSave = () => {
        props.showConfirmDialog("Confirm create Transaction?", undefined, () => {
            props.closeConfirmDialog();
            setLoading(true);
            save();
        });
    }

    const save = () => {
        let header = {'user-id' : props.user.id, 'user-name': props.user.name };
        let body = transaction;
        body.products = tproducts;
        delete body.current_stock;
        console.log(body);

        WarehouseService.createTransaction(header, body)
        .then((data) => {
            if(data.success){
                props.showSnackBar(`Transaction Created.`, 'success');
                props.save();
                props.close();
                setOpen(false);
                setTProducts([]);
                setAddItemRows([]);
                setTransaction({txn_date: moment()});
            } else {
                props.showSnackBar(`Failed for one or more entries.`, 'error');
            }
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            props.showSnackBar(`Failed to create Transaction. Please check again or contact Admin.`, 'error');
            setLoading(false);
        });
    }
 
    const handleClose = () => {
        props.showConfirmDialog("Cancel transaction?", "Confirm", () => {
            props.close();
            props.closeConfirmDialog();
            setOpen(false);
            setTProducts([]);
            setAddItemRows([]);
            setTransaction({txn_date: moment()});
        });
    };

    const removeItems = () => {
        setTProducts(tproducts.filter(p => checkedList.indexOf(p.rowid) === -1));
        setCheckedList([]);
    }

    return (
        <Dialog fullScreen fullWidth maxWidth={"xl"} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                <IconButton color="inherit" onClick={handleClose} aria-label="Close">
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" color="inherit" className={classes.flex}>
                    {title}
                </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent dividers>
                <Grid container justify="flex-start" alignItems="center" direction="row">
                    <Grid item xs={12} lg={12}>
                        <Fade
                            in={loading}
                            style={{
                                transitionDelay: loading ? '10ms' : '0ms'
                            }}
                            unmountOnExit
                            >
                            <CircularProgress style={{position: "fixed", top: "50%", left: "50%"}}/>
                        </Fade>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        {
                            checkedList.length > 0 ?
                                <div style={{backgroundColor: theme.palette.primary.dark}}>
                                    <CardHeader 
                                        title={`${checkedList.length} Selected`}
                                        titleTypographyProps={{style: {color: '#ffffff'}}}
                                        className={classes.selectedHeader}
                                        style={{paddingTop: 8, paddingBottom: 8}}
                                        action={
                                            <div> 
                                                <HtmlTooltip title="Remove Items">
                                                    <IconButton aria-label="Remove Items" style={{color: '#ffffff'}} size="medium" onClick={removeItems}>
                                                        <DeleteIcon style={{marginTop: 6}} className={classes.iconSelected}/>
                                                    </IconButton>
                                                </HtmlTooltip>
                                            </div>
                                        }
                                    />
                                </div>
                            :
                                details
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <List className={classes.list}>                               
                            {addItemRows}
                        </List>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    autoFocus 
                    onClick={handleSave} 
                    color="primary" 
                    variant="contained"
                    disabled={!(transaction.source_id && transaction.destination_id && transaction.stock_type && transaction.txn_date && tproducts.length > 0) || loading}>
                    Save
                </Button>
                <Button autoFocus onClick={handleClose} color="secondary" >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}